import styled, { css } from 'styled-components';
import defaultBg from '../assets/default-bg.webp';

export const defaultColor = {
  main: '#0c0c0c',
  secondary: '#B08AF7',
  gradientTop: '#BD94FF',
  gradientBottom: '#885BCF',
  clock: '#ffffff',
};

const defaultPageStyle = css`
  background-color: ${defaultColor.main};
  background-image: url(${defaultBg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  max-width: 480px;
  height: 100%;
  margin: 0 auto;
`;

export const DownloadPageWrap = styled.div`
  ${defaultPageStyle};
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
`;

export const LogoWrap = styled.h1`
  position: relative;
  margin: 36px 0;
  display: block;
  width: 102px;
  height: 12px;
  min-height: 12px;

  img {
    width: 102px;
    height: 12px;
    min-height: 12px;
  }
`;

export const FixedLogoWrap = styled(LogoWrap)`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
`;

export const TimeOverPageWrap = styled.div`
  ${defaultPageStyle};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #fff;
  z-index: 1;
  height: 100vh;

  > h2 {
    font-weight: 700;
    font-size: 26px;
    line-height: 22px;
    display: block;
    font-family: 'Pretendard', sans-serif;
  }

  > p {
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
  }
`;
